module.exports = __webpack_public_path__ + "img/training_w.758dd219.svg";